import { CALL_API } from '../../../../common/middleware/api';

export const TAKEPAYMENTS_CARD_UPDATE_REQUEST = 'TAKEPAYMENTS_CARD_UPDATE_REQUEST';
export const TAKEPAYMENTS_CARD_UPDATE_SUCCESS = 'TAKEPAYMENTS_CARD_UPDATE_SUCCESS';
export const TAKEPAYMENTS_CARD_UPDATE_FAILURE = 'TAKEPAYMENTS_CARD_UPDATE_FAILURE';

export const updatePaymentOption = (payment) => (dispatch) => {
	if (payment && payment.paymentMethod && payment.paymentMethod.name === 'Takepayments') {
		dispatch({
			[CALL_API]: {
				types: [TAKEPAYMENTS_CARD_UPDATE_REQUEST, TAKEPAYMENTS_CARD_UPDATE_SUCCESS, TAKEPAYMENTS_CARD_UPDATE_FAILURE],
				endpoint: 'api/paymentMethods/takepayments/cardUpdate',
				method: 'POST',
				request: { paymentId: payment.id },
				onSuccess: (response) => {
					if (response.redirectUrl) {
						const bodyParams = response.httpBodyParams || {};
						const form = document.createElement('form');
						form.method = 'POST';
						form.action = response.redirectUrl;
						form.style.display = 'none';
						Object.keys(bodyParams).forEach(key => {
							const input = document.createElement('input');
							input.name = key;
							input.value = bodyParams[key];
							input.type = 'hidden';
							form.appendChild(input);
						});
						document.body.appendChild(form);
						form.submit();
					}
				}
			}
		});
	}
};
